module.exports = __webpack_public_path__ + "img/08fba59.png";